export default __webpack_public_path__ + "static/ZMG_E-Paper-Qualitaeten2024-start-b7cba8e2a7849a2f5145fc0e85c4ca59.png";